const Constants = {
    BASE_URL: "https://crm-uat-api.brands.com.tw/api/taiwan/",
    ASSETS_BASE_URL: "https://d3brttk7f7eduo.cloudfront.net", //uat

    GET_REGISTER_OPTIONS: "twauth/getregistrationoptions",
    GET_IP_ADDRESS: "https://api.ipify.org/?format=json",
    GET_ACTIVE_SIGNUP_REWARDS: "auth/getactivesignuprewards",

    USER_REGISTRATION: "twauth/register",
    VALIDATE_CONSUMER_MOBILE: "twconsumer/validatemembermobileno",

    //Home
    GET_REWARD_POINTS: "twconsumer/getrewardsdetails",
    FEED_CHICKEN: "twconsumer/feedchicken",
    GET_CAROUSEL_BANNERS: "twconsumer/getcarousels",
    GET_FIRST_RECEIPT_APPROVAL_STATUS: "twconsumer/getanimationpopup",
    COMPLETED_FIRST_RECEIPT_NOTIFICATION: "twconsumer/updateanimationpopup",

    //Mission Center
    GET_MISSION_CENTER: "twconsumer/getmissions",
    GET_WATCH_AD_MISSION: "twconsumer/getvideos",
    SUBMIT_WATCH_AD_MISSION: "twconsumer/completevideomission",
    GET_QUIZ_QUESTIONS: "twconsumer/gettwquizquestions",
    SUBMIT_QUIZ_QUESTIONS: "twconsumer/submittwquizmission",
    GET_FEEDBACK_QUESTIONS: "twconsumer/gettwfeedbackquestions",
    SUBMIT_FEEDBACK_QUESTIONS: "twconsumer/submittwfeedbackmission",

    //Rewards
    GET_REWARD_CATEGORIES: "twrewards/getrewardcategories",
    GET_REWARD_DETAILS: "twrewards/getrewarddetails",
    GET_REWARD_PRODUCTS: "twrewards/getrewardproducts",
    GET_REWARD_PRODUCT_DETAILS: "twrewards/getrewardproductdetails",
    PURCHASE_REWARD: "twrewards/purchasereward",

    //Reward History
    GET_EXPIRY_POINTS: "twrewards/getexpirypoints",
    GET_REDEEMED_VOUCHERS: "twrewards/getvouchers",
    GET_CUSTOM_REWARD_VOUCHERS: "twrewards/getcustomrewarddetails",
    GET_MONTH_YEAR: "twrewards/getmonthyear",
    GET_POINTS_TRANSACTIONS: "twrewards/gettransactions",
    
    UPLOAD_CERTIFICATE: "receiptupload/installment-certificate/upload",
    UPLOAD_RECEIPT: "receiptupload/government/upload",
    EXTRACT_RECEIPT_DETAILS: "receiptupload/extract",
    GET_UPLOADED_RECEIPTS: "receiptupload/member",
    GET_MEMBER_BAR_CODE: "receiptupload/member-barcode",

    GET_MEMBER_PROFILE: "twconsumer/getmemberprofile",
    GET_FREQUENTLY_ASKED: "twconsumer/getfaq",
    UPDATE_MEMBER_PROFILE: "twconsumer/updatememberprofile",
    CANCEL_MEMBERSHIP: "twconsumer/cancelmembership",

    GET_PRE_SIGNED_URL: "tws3presignedurl/generate-presigned-urls",

    //Login APIs
    ADD_MEMBER: "twauth/login",
    LIFF_ID: '2001669248-kRYJCyTe' //uat
};

export default Constants;